export const SHOW_USER_DETAILS = 'SHOW_USER_DETAILS';
